import { isNumeric } from '@util/number';
import { complement, compose, flip, join, length, reject, take } from 'ramda';

const TIME_PARSING_TOKENS: Readonly<string[]> = ['H', 'H', 'm', 'm', 's', 's'];

const shortenToMatchTokens = take(length(TIME_PARSING_TOKENS));
const timeTokensOf = flip(take)(TIME_PARSING_TOKENS);
const toTimeFormat = join('');

const notANumber = complement(isNumeric);
const onlyNumbers = reject(notANumber);

type TimeFormatFromInput = (input: string) => string;
export const timeFormatFromInput: TimeFormatFromInput = compose(
  toTimeFormat,
  timeTokensOf,
  length,
  shortenToMatchTokens,
  onlyNumbers
);
